jQuery.noConflict();
(function($){
//
// Header Banner  
// 
var slider = $(".mobile-header-slider"); 
slider.slick({  
  slide: 'div',   
  autoplay: true, 
  autoplaySpeed: 2400,               
  dots: false,  
  arrows: true,   
  prevArrow: $('.hero-previous'),  
  nextArrow: $('.hero-next'), 
  slidesToShow: 1, 
  slidesToScroll: 1   
});   

$(window).on("load resize",function(e){ 
   
  var windowWidth = $( window ).width(); 

    if (windowWidth < 1039) {     
      slider.not(".slick-initialized").slick();
    } else if (slider.hasClass("slick-initialized")) {
      slider.slick("unslick");
    }

}); 

}(jQuery)); 